/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigNoContentResponse,
  BboBranchConfigUnauthorizedResponse,
  StockCount,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get stock count list for a branch
 * @summary Get the stock counts type list for a branch
 */
export const getStockCountTypes = (signal?: AbortSignal) => {
  return customInstance<StockCount | BboBranchConfigNoContentResponse>({
    url: `/BboBranchConfigService/v1/stock-count-types`,
    method: 'get',
    signal,
  });
};

export const getGetStockCountTypesQueryKey = () => {
  return [`/BboBranchConfigService/v1/stock-count-types`] as const;
};

export const getGetStockCountTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockCountTypes>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCountTypes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockCountTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockCountTypes>>> = ({ signal }) =>
    getStockCountTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockCountTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockCountTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockCountTypes>>
>;
export type GetStockCountTypesQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get the stock counts type list for a branch
 */
export const useGetStockCountTypes = <
  TData = Awaited<ReturnType<typeof getStockCountTypes>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCountTypes>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockCountTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
